import {CoreGameConfig} from '@gongxigames/framework/core/types/CoreGameConfig';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';

export const slotGameConfig: CoreGameConfig = {
    layers: LAYERS,
    mainFrame: {
        width: 3840,
        height: 2160
    },
    viewport: {
        mobile: {
            width: 3840,
            height: 2160
        },
        desktop: {
            width: 3840,
            height: 2236 // 2160 + bottomPanel height
        }
    }
};
